// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Nossa política de privacidade é bem simples!',
  text: `Nós gravamos em teu computador apenas três cookies, que são essenciais para o bom funcionamento desta aplicação:
  ARRAffinity (identifica qual instância de servidor está sendo acessada), AuthCookie (autenticação) e ConsentCookie
  (Política de privacidade).`,
} as ILanguage;
